import ProveedorForm from './ProveedorForm'
export {ProveedorForm}
export default ProveedorForm
